import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supportTicketServices } from '../services/support-ticket.service';
import toast from 'react-hot-toast';

export const useUpdateTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ticketId, data }) => supportTicketServices.updateTicket({ ticketId, data }),
    onSuccess: () => {
      queryClient.invalidateQueries(['support-tickets']);
      toast.success('Ticket updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update ticket');
    },
  });
};
